export const checkIsTrueOrThrow = (conditional, errorMessage) => {
    if (!conditional) {
        throw new Error(errorMessage);
    }
};
